<div class="dialog-container">
  <div class="first">
    <ng-lottie width="40px" height="40px" [options]="options" (animationCreated)="animationCreated($event)"></ng-lottie>
    <img src="assets/main-page/autolock.svg" class="image" />
  </div>
  <div class="second">
    Initiating
    <b>Auto-{{ signout }}</b>
    .
  </div>
</div>
